import { useLang } from "@/context/LanguageContext";
import Reveal from "./Reveal";

export default function SectionHeading({ eyebrow, title, sub, center = false }) {
  const { pick } = useLang();
  return (
    <Reveal className={`mb-12 max-w-2xl ${center ? "mx-auto text-center" : ""}`}>
      <p className="eyebrow mb-3">{pick(eyebrow.ar, eyebrow.en)}</p>
      <h2 className="text-2xl font-bold leading-snug tracking-tight text-white sm:text-3xl lg:text-4xl">{pick(title.ar, title.en)}</h2>
      {sub && <p className="mt-4 text-base leading-8 text-mist">{pick(sub.ar, sub.en)}</p>}
    </Reveal>
  );
}
